export var modalBody = {
  padding: '2.4rem',
  minWidth: 340,
  maxWidth: 680,
  width: '100%'
};
export var modalHeader = function modalHeader(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.8rem',
    marginBottom: '2rem',
    '& i': {
      fontSize: '2rem',
      color: theme.primary
    },
    '& h4': {
      margin: 0,
      fontSize: '1.6rem',
      fontWeight: 600,
      color: theme.gray800
    }
  };
};
export var zonesRow = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '1.2rem',
  marginBottom: '1.6rem',
  '@media (max-width: 480px)': {
    gridTemplateColumns: '1fr'
  }
};
export var uploadZoneStyle = function uploadZoneStyle(hasFile) {
  return function (theme) {
    return {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      border: "2px dashed ".concat(hasFile ? theme.primary : theme.gray200),
      borderRadius: 8,
      overflow: 'hidden',
      backgroundColor: hasFile ? theme.primaryLight : theme.gray50,
      transition: 'border-color 0.2s, background-color 0.2s',
      minHeight: 160
    };
  };
};
export var zonePreview = {
  width: '100%',
  maxHeight: 180,
  objectFit: 'cover',
  flex: 1
};
export var zonePlaceholder = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  padding: '1.6rem 1rem'
};
export var zoneIcon = function zoneIcon(theme) {
  return {
    fontSize: '2.8rem',
    color: theme.gray400,
    marginBottom: '0.4rem'
  };
};
export var zoneLabel = function zoneLabel(theme) {
  return {
    fontSize: '1.2rem',
    color: theme.gray600,
    fontWeight: 500
  };
};
export var zoneActions = function zoneActions(theme) {
  return {
    display: 'flex',
    width: '100%',
    borderTop: "1px solid ".concat(theme.gray150)
  };
};
export var zoneBtn = function zoneBtn(theme) {
  return {
    flex: 1,
    padding: '0.6rem 0.4rem',
    background: 'none',
    border: 'none',
    borderRight: "1px solid ".concat(theme.gray150),
    fontSize: '1.2rem',
    color: theme.primary,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.4rem',
    '&:last-child': {
      borderRight: 'none'
    },
    '&:hover': {
      backgroundColor: theme.primaryLight
    }
  };
};
export var zoneBtnClear = function zoneBtnClear(theme) {
  return {
    padding: '0.6rem 0.8rem',
    background: 'none',
    border: 'none',
    borderLeft: "1px solid ".concat(theme.gray150),
    fontSize: '1.3rem',
    color: theme.danger,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.dangerLight
    }
  };
};
export var recognizeRow = {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '1.6rem'
};
export var resultsSection = function resultsSection(theme) {
  return {
    borderTop: "1px solid ".concat(theme.gray100),
    paddingTop: '1.6rem',
    marginBottom: '1.6rem'
  };
};
export var resultsTitle = function resultsTitle(theme) {
  return {
    fontSize: '1.3rem',
    color: theme.gray600,
    marginBottom: '1rem'
  };
};
export var addressHint = function addressHint(theme) {
  return {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '0.8rem 1rem',
    backgroundColor: '#fff8e1',
    border: '1px solid #ffe082',
    borderRadius: 6,
    fontSize: '1.2rem',
    color: '#795548',
    marginBottom: '1rem',
    lineHeight: 1.5
  };
};
export var resultsTable = {
  width: '100%',
  borderCollapse: 'collapse'
};
export var resultsTh = function resultsTh(theme) {
  return {
    padding: '0.5rem 0.8rem 0.5rem 0',
    fontSize: '1.2rem',
    color: theme.gray600,
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    width: '40%'
  };
};
export var resultsTd = {
  padding: '0.3rem 0',
  verticalAlign: 'middle'
};
export var editInput = function editInput(theme) {
  return {
    width: '100%',
    padding: '0.4rem 0.6rem',
    fontSize: '1.3rem',
    border: "1px solid ".concat(theme.gray200),
    borderRadius: 4,
    outline: 'none',
    color: theme.gray800,
    backgroundColor: theme.white,
    '&:focus': {
      borderColor: theme.primary
    }
  };
};
export var footerRow = {
  display: 'flex',
  justifyContent: 'flex-end',
  paddingTop: '1.2rem'
};